import { id } from "./id.mjs";
export function createMessage(args) {
  return {
    id: id(),
    type: args.type,
    payload: args.payload
  };
}